import { groupTagsByType } from "@helpers/content/tag";
import { getShowStudyPackViews } from "@helpers/exams";
import { useAppStore } from "@hooks/useAppStore";
import type { MixedItemDist } from "@memorang/types";

export const getQuickActionsChips = (studyPackCollectionId?: number) => {
	const showStudyPackViews = getShowStudyPackViews(studyPackCollectionId);
	const chips = [
		...(showStudyPackViews
			? [
					{
						label: "Study weak areas",
						type: "weak" as const,
						icon: "alert-decagram-outline",
						tooltip:
							"Focus on areas where you are weak to improve your overall performance",
					},
				]
			: []),
		{
			label: "View progress",
			type: "progress" as const,
			icon: "chart-timeline-variant-shimmer",
			tooltip: "Track your progress and see how you are improving",
		},
		{
			label: "View rank",
			type: "leaderboard" as const,
			icon: "podium-gold",
			tooltip: "See how you rank against others",
		},
	];
	return chips;
};

export const getWeakTagsIds = (mixedItemDist: MixedItemDist) => {
	const { tags, freeTagIds } = mixedItemDist;
	const groupedTagsByType = groupTagsByType(tags, "Progress", freeTagIds);
	const allTags = Object.keys(groupedTagsByType).flatMap(
		(key) => groupedTagsByType[key],
	);

	const sortedMasteryLevels = useAppStore.getState().app.masteryLevels!;
	const lowLevelTags = sortedMasteryLevels.filter((tag) => tag.level === "low");

	const lowScoredTags = allTags.filter((item) => {
		const distKeys = Object.keys(item.distribution);
		return lowLevelTags.some(
			(tag) => distKeys.includes(tag.id) && item.distribution[tag.id] > 0,
		);
	});

	const ids = lowScoredTags.map((tag) => tag.id);
	return ids;
};
